export default {
  placeholder: 'Select an asset level',
};
